// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visibleText_Cza1n {
  white-space: nowrap;
  overflow: hidden;
}

.measureText_wIEh8 {
  position: absolute;
  visibility: hidden;
  height: auto;
  white-space: nowrap;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FileExplorer/TruncatedText/TruncatedText.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".visibleText {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.measureText {\n  position: absolute;\n  visibility: hidden;\n  height: auto;\n  white-space: nowrap;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visibleText": `visibleText_Cza1n`,
	"measureText": `measureText_wIEh8`
};
export default ___CSS_LOADER_EXPORT___;
